/*
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         6/05/24 - 13:20:07
 * Module name:  mkad-users.services
 * File name:    mkad-users.services.ts
 * IDE:          WebStorm
 */
import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {map, Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {HTTP_CODE_SUCCESS} from '@shared/constants';
import {UserFormInterface, UserListInterface} from '@shared/interface';

@Injectable()
export class MkadUsersService extends MkadBaseService {
  readonly customer = URLS_SERVICE.meerkad.customer;
  readonly users = URLS_SERVICE.meerkad.user;

  list(): Observable<UserListInterface[] | null> {
    return this.http.post<UserListInterface[] | null>(this.customer.base + this.users.base + this.users.list);
  }

  get(userId: number): Observable<UserFormInterface> {
    return this.http.post<UserFormInterface>(this.customer.base + this.users.base + this.users.get, {id: userId});
  }

  create(payload: UserFormInterface): Observable<UserFormInterface> {
    return this.http.post<UserFormInterface>(this.customer.base + this.users.base + this.users.create, payload);
  }

  createSuperAdmin(payload: UserFormInterface): Observable<UserFormInterface> {
    return this.http.post<UserFormInterface>(this.customer.base + this.users.base + this.users.createSuperAdmin, payload);
  }

  update(payload: UserFormInterface): Observable<UserFormInterface> {
    return this.http.post<UserFormInterface>(this.customer.base + this.users.base + this.users.update, payload);
  }

  delete(userId: number): Observable<boolean> {
    return this.http.post<HttpResponse<boolean>>(this.customer.base + this.users.base + this.users.delete, {id: userId}).pipe(
      map((prevResponse) => {
          if (!prevResponse) return true;
          return prevResponse.status === HTTP_CODE_SUCCESS;
        },
      ));
  }

}
